import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
    const { login, user } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => { if (user) navigate("/admin"); }, [user, navigate]);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Welcome back");
            navigate("/admin");
        } else {
            setError(res.error);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[var(--navy)] px-6" data-testid="admin-login-page">
            <div className="grain-overlay" aria-hidden />
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
                className="w-full max-w-md border border-[rgba(201,162,75,0.4)] bg-[var(--navy-deep)] p-8 md:p-10"
            >
                <div className="label-mono text-[var(--gold)]">— ADMIN CONSOLE</div>
                <h1 className="serif-display text-4xl mt-3 mb-8">Z<span className="text-[var(--gold)]">•</span>SGI</h1>
                <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
                    <div>
                        <label className="label-mono block mb-2">Email</label>
                        <input required type="email" className="input-editorial" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" autoComplete="username" />
                    </div>
                    <div>
                        <label className="label-mono block mb-2">Password</label>
                        <input required type="password" className="input-editorial" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" autoComplete="current-password" />
                    </div>
                    {error && <p className="label-mono text-[#e07a7a]" data-testid="admin-login-error">{error}</p>}
                    <button type="submit" disabled={loading} className="btn-gold w-full justify-center" data-testid="admin-login-submit">
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>
                <a href="/" className="label-mono text-[var(--ivory)]/50 hover:text-[var(--ivory)] transition-colors mt-8 inline-block">← Back to site</a>
            </motion.div>
        </div>
    );
}
